// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"235":"f74be6d5","404":"ce91a0ad","787":"7e8af3b7"}[chunkId] + ".chunk.js";
};